var $ = window.jQuery = require('jquery');
import game_header from '../../components/game-header/index.vue';
var status = 1,
  clicked_id = 0,
  click = 0,
  level = 1,
  id = 0,
  timeinterval;
export default {
  name: 'go-for-morkov',
  components: {
    'game-header': game_header
  },
  props: [],
  data() {
    return {
      totalTime: 90,
      countDown: {
        minutes: 0,
        seconds: 0
      }
    }
  },
  computed: {

  },
  mounted() {
    $('.routeloader').show();
    setTimeout(() => {
      $('.routeloader').hide();
    }, 2000)
  },
  methods: {
    initializeTimer: function (endTime) {
      var _self = this;

      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        if (remainTime.total < 10000) {
          $('.game_timer').addClass("blink_me");
        }
        if (remainTime.total <= 0) {
          clearInterval(timeinterval);
          $(".load-matrix").html("<h2 style='text-align:center;'>Time up! Reset to play again.</h2>")
          alert('Time up! Reset to play again.');
        }
      }
      updateClock();
      timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    bindDOM: function (checkMatrix = false) {
      if (checkMatrix) {
        check_matrix();
      } else {

        $('.help-cell').click(function () {
          if (click == 0 && status == 1) {
            clicked_id = "#" + $(this).attr('id');
            click = 1;
            let num1 = $(this).html();
            $(this).css('color', 'yellow');
            $('.matrix-cell').click(function () {
              if (click == 1) {
                $(this).html(num1);
                //delete num1;
                $(this).css('color', 'yellow');
                click = 0;
                check_matrix();
              };
            });
          };

          if (click == 1 && status == 1) {
            $(clicked_id).css('color', 'white');
            clicked_id = "#" + $(this).attr('id');
            let num1 = $(this).html();
            $(this).css('color', 'yellow');
            $('.matrix-cell').click(function () {
              if (click == 1) {
                $(this).html(num1);
                //delete num1;
                $(this).css('color', 'yellow');
                click = 0;
                check_matrix();
              };
            });
          };
        });

        $('.matrix-cell').click(function () {
          if (click == 0 && status == 1) {
            clicked_id = "#" + $(this).attr('id');
            click = 2;
            id = $(this).attr('id');
            id = '#' + id;
            $(this).css('color', 'yellow');
            $('.help-cell').click(function () {
              if (click == 2) {
                let num1 = $(this).html();
                $(id).html(num1);
                //delete num1;
                $(this).css('color', 'yellow');
                click = 0;
                check_matrix();
              };
            });
          };
          if (click == 2 && status == 1) {
            $(clicked_id).css('color', 'white');
            clicked_id = "#" + $(this).attr('id');
            id = $(this).attr('id');
            id = '#' + id;
            $(this).css('color', 'yellow');
            $('.help-cell').click(function () {
              if (click == 2) {
                let num1 = $(this).html();
                $(id).html(num1);
                //delete num1;
                $(this).css('color', 'yellow');
                click = 0;
                check_matrix();
              };
            });
          };
        });

        $('#instruction-modal').modal('hide');
        $('#start').hide() || $(this).hide();
        $('#reset').show();

        $(".help-cell").draggable({ //Initializing drag and drop
          revert: true
        });

        $(".matrix-cell").droppable({
          accept: ".help-cell",
          drop: Drop,
          over: Hover,
          out: DragOut
        });

        check_matrix();

        $('.game_timer').removeClass("blink_me");
        var totalTime = new Date();
        totalTime.setSeconds(totalTime.getSeconds() + this.totalTime);
        this.initializeTimer(totalTime)
      }

      function Drop(event, ui) {
        var helpCell = ui.draggable.text();
        var helpCellId = '#' + ui.draggable.attr('id');
        $(this).text(helpCell);
        $(this).css("color", "yellow");
        $(helpCellId).css("color", "yellow");
        click = 2;
        $(this).css("background-color", "#373737");
        check_matrix();
      }

      function Hover(event, ui) {
        $(this).css("background-color", "#00FFF1");
      }

      function DragOut(event, ui) {
        $(this).css("background-color", "#373737");
      }

      // Matrix check and sum of each column
      function check_matrix() {
        var v1 = $('#col_11').html();
        var v2 = $('#col_21').html();
        var v3 = $('#col_31').html();
        var vn4 = $('#col_41').html() || 0;
        var v51 = $('#col_51').html() || 0;
        var value_1 = parseFloat(v1) * 10;
        var value_2 = parseFloat(v2) * 10;
        var value_3 = parseFloat(v3) * 10;
        var value_n4 = parseFloat(vn4) * 10;
        var value_51 = parseFloat(v51) * 10;
        var sum1 = value_1 + value_2 + value_3 + value_n4 + value_51;
        // $("#sum1").html(sum1/10);


        var v4 = $('#col_12').html();
        var v5 = $('#col_22').html();
        var v6 = $('#col_32').html();
        var vn7 = $('#col_42').html() || 0;
        var v52 = $('#col_52').html() || 0;
        var value_4 = parseFloat(v4) * 10;
        var value_5 = parseFloat(v5) * 10;
        var value_6 = parseFloat(v6) * 10;
        var value_n7 = parseFloat(vn7) * 10;
        var value_52 = parseFloat(v52) * 10;
        var sum2 = value_4 + value_5 + value_6 + value_n7 + value_52;
        // $("#sum2").html(sum2/10);

        var v7 = $('#col_13').html();
        var v8 = $('#col_23').html();
        var v9 = $('#col_33').html();
        var v10 = $('#col_43').html() || 0;
        var v53 = $('#col_53').html() || 0;
        var value_7 = parseFloat(v7) * 10;
        var value_8 = parseFloat(v8) * 10;
        var value_9 = parseFloat(v9) * 10;
        var value_10 = parseFloat(v10) * 10;
        var value_53 = parseFloat(v53) * 10;
        var sum3 = value_7 + value_8 + value_9 + value_10 + value_53;
        // $("#sum3").html(sum3/10);

        var v11 = $('#col_14').html() || 0;
        var v12 = $('#col_24').html() || 0;
        var v13 = $('#col_34').html() || 0;
        var v14 = $('#col_44').html() || 0;
        var v54 = $('#col_54').html() || 0;
        var value_11 = parseFloat(v11) * 10;
        var value_12 = parseFloat(v12) * 10;
        var value_13 = parseFloat(v13) * 10;
        var value_14 = parseFloat(v14) * 10;
        var value_54 = parseFloat(v54) * 10;
        var sum4 = value_11 + value_12 + value_13 + value_14 + value_54;
        // console.log(value_11);
        // console.log(value_12);
        // console.log(value_13);
        // console.log(value_14);
        // console.log(value_54);

        var v15 = $('#col_15').html() || 0;
        var v25 = $('#col_25').html() || 0;
        var v35 = $('#col_35').html() || 0;
        var v45 = $('#col_45').html() || 0;
        var v55 = $('#col_55').html() || 0;
        var value_15 = parseFloat(v15) * 10;
        var value_25 = parseFloat(v25) * 10;
        var value_35 = parseFloat(v35) * 10;
        var value_45 = parseFloat(v45) * 10;
        var value_55 = parseFloat(v55) * 10;
        var sum5 = value_15 + value_25 + value_35 + value_45 + value_55;

        // console.log(sum1);
        // console.log(sum2);
        // console.log(sum3);
        // console.log(sum4);
        // console.log(sum5);
        console.log(level);
        if (sum1 == 10 && sum2 == 10 && sum3 == 10 && sum4 == 10 && sum5 == 10 && level == 3) {
          clearInterval(timeinterval);
          $('#congrats').modal('show');
        } else if (sum1 == 10 && sum2 == 10 && sum3 == 10 && sum4 == 10 && level == 2) {
          clearInterval(timeinterval);
          $('#congrats').modal('show');
        } else if (sum1 == 10 && sum2 == 10 && sum3 == 10 && level == 1) {
          clearInterval(timeinterval);
          $('#congrats').modal('show');
        }

      }
    },
    startHowModal: function () {
      $('.how-to-play').modal('hide');
      $("#start-how-modal").hide();
      this.startGame();
    },
    startGame: function () {
      $(".load-matrix").hide();
      $("#m-loader").show();
      $("#start-how-modal").hide();
      level = 1;
      let data = this.generateMatrix(level, false);
      $(".bracket").hide();
      $(".load-matrix").html(data);
      $("#m-loader").hide();
      $(".load-matrix").fadeIn();
      $(".bracket").fadeIn();
      this.bindDOM();
    },
    endGame: function () {
      $('#congrats').modal('hide');
      let data = this.generateMatrix(level, true);
      $(".load-matrix").hide();
      $('#reset').hide();
      $(".bracket").hide();
      $(".load-matrix").html(data);
      $('.help-cell').hide();
      clearInterval(timeinterval);
      this.countDown.minutes = 0;
      this.countDown.seconds = 0;
      this.totalTime = 90;
      $(".load-matrix").fadeIn();
    },
    nextLevel: function () {
      var _self = this;
      $(".load-matrix").hide();
      $("#m-loader").show();
      $('#congrats').modal('hide');
      level += 1;
      let data = this.generateMatrix(level, false);
      $(".bracket").hide();
      if (document.documentElement.clientWidth < 1000) {
        $(".bracket").css("height", "270px");
      } else if (document.documentElement.clientWidth > 1400) {
        $(".bracket").css("height", "550px");
      } else {
        $(".bracket").css("height", "350px");
      }
      $(".load-matrix").html(data);
      $('.help-cell').css('color', '#FEFAB1');
      clearInterval(timeinterval);
      this.countDown.minutes = 0;
      this.countDown.seconds = 0;
      this.totalTime = 90;
      $("#m-loader").hide();
      $(".load-matrix").fadeIn();
      $(".bracket").fadeIn(function () {
        _self.bindDOM();
      });
      if (level == 3) {
        $("#next-lvl").hide();
        $("#col-b-l").css("padding-right", "0");
        $("#col-b-r").css("padding-left", "0");
      }
      $("#start-how-modal").hide();
    },
    resetGame: function () {
      var _self = this;
      $(".load-matrix").hide();
      $("#m-loader").show();
      $("#loader").show();
      let data = this.generateMatrix(level, false);
      $(".bracket").hide();
      $(".load-matrix").html(data);
      $("#m-loader").hide();
      $(".load-matrix").fadeIn(function () {
        _self.bindDOM();
      });
      $(".bracket").fadeIn();
      $('.help-cell').css('color', '#FEFAB1');
      clearInterval(timeinterval);
      this.countDown.minutes = 0;
      this.countDown.seconds = 0;
      this.totalTime = 90;
      $('.game_timer').removeClass("blink_me");
      this.bindDOM(true);

    },
    generateMatrix: function (level, quitGame) {
      let matrixContent = '';
      if ((quitGame && level == 1) || (quitGame && level == 3) || (quitGame && level == 3)) {
        matrixContent = `<div style='text-align:center;'><h1>Thanks for playing</h1></div>`;
      } else if (level == 1) {
        let matrix = this.getMatrix(level);
        let topRow = `<div class="row row_t col-row">
                            <div class="col-4 cell-pad col_l" col="left">
                              <div id="col_11" class="matrix-cell f-right">
                                ${matrix[0]}
                              </div>
                            </div>
                            <div class="col-4 cell-pad col_m" col="middle">
                              <div id="col_12" class="matrix-cell">
                                ${matrix[1]}
                              </div>
                            </div>
                            <div class="col-4 cell-pad col_r" col="right">
                              <div id="col_13" class="matrix-cell f-left">
                                ${matrix[2]}
                              </div>
                            </div>
                          </div>`;
        let middleRow = `<div class="row row_m col-row">
                            <div class="col-4 cell-pad col_l" col="left">
                              <div id="col_21" class="matrix-cell f-right">
                                ${matrix[3]}
                              </div>
                            </div>
                            <div class="col-4 cell-pad col_m" col="middle">
                              <div id="col_22" class="matrix-cell">
                                ${matrix[4]}
                              </div>
                            </div>
                            <div class="col-4 cell-pad col_r" col="right">
                              <div id="col_23" class="matrix-cell f-left">
                                ${matrix[5]}
                              </div>
                            </div>
                          </div>`;
        let bottomRow = `<div class="row row_b col-row">
                          <div class="col-4 cell-pad col_l" col="left">
                            <div id="col_31" class="matrix-cell f-right">
                              ${matrix[6]}
                            </div>
                          </div>
                          <div class="col-4 cell-pad col_m" col="middle">
                            <div id="col_32" class="matrix-cell">
                              ${matrix[7]}
                            </div>
                          </div>
                          <div class="col-4 cell-pad col_r" col="right">
                            <div id="col_33" class="matrix-cell f-left">
                              ${matrix[8]}
                            </div>
                          </div>
                        </div>`;
        matrixContent = topRow + middleRow + bottomRow;
      } else if (level == 2) {
        let matrix = this.getMatrix(level);
        let topRow = `<div class="row row_t col-row row-4">
                            <div class="col-3 cell-pad">
                              <div id="col_11" class="matrix-cell f-right">
                                ${matrix[0]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_12" class="matrix-cell">
                                ${matrix[1]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_13" class="matrix-cell f-left">
                                ${matrix[2]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_14" class="matrix-cell f-left">
                                ${matrix[3]}
                              </div>
                            </div>
                          </div>`;
        let middleRow = `<div class="row row_m col-row row-4">
                            <div class="col-3 cell-pad">
                              <div id="col_21" class="matrix-cell f-right">
                                ${matrix[4]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_22" class="matrix-cell">
                                ${matrix[5]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_23" class="matrix-cell f-left">
                                ${matrix[6]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_24" class="matrix-cell f-left">
                                ${matrix[7]}
                              </div>
                            </div>
                          </div>`;
        let bottomRow = `<div class="row row_b col-row row-4">
                            <div class="col-3 cell-pad">
                              <div id="col_31" class="matrix-cell f-right">
                                ${matrix[8]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_32" class="matrix-cell">
                                ${matrix[9]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_33" class="matrix-cell f-left">
                                ${matrix[10]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_34" class="matrix-cell f-left">
                                ${matrix[11]}
                              </div>
                            </div>
                          </div>`;
        let lastRow = `<div class="row col-row mb-20 row-4">
                            <div class="col-3 cell-pad">
                              <div id="col_41" class="matrix-cell f-right">
                                ${matrix[12]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_42" class="matrix-cell">
                                ${matrix[13]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_43" class="matrix-cell f-left">
                                ${matrix[14]}
                              </div>
                            </div>
                            <div class="col-3 cell-pad">
                              <div id="col_44" class="matrix-cell f-left">
                                ${matrix[15]}
                              </div>
                            </div>
                          </div>`;
        matrixContent = topRow + middleRow + bottomRow + lastRow;
      } else if (level == 3) {
        let matrix = this.getMatrix(level);
        let topRow = `<div class="row row_t col-row row-5">
                            <div class="col-1"></div>
                            <div class="col-2 cell-pad">
                              <div id="col_11" class="matrix-cell f-right">
                                ${matrix[0]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_12" class="matrix-cell">
                                ${matrix[1]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_13" class="matrix-cell f-left">
                                ${matrix[2]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_14" class="matrix-cell f-left">
                                ${matrix[3]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_15" class="matrix-cell f-left">
                                ${matrix[4]}
                              </div>
                            </div>
                            <div class="col-1"></div>
                          </div>`;
        let middleRow = `<div class="row row_m col-row row-5">
                            <div class="col-1"></div>
                            <div class="col-2 cell-pad">
                              <div id="col_21" class="matrix-cell f-right">
                                ${matrix[5]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_22" class="matrix-cell">
                                ${matrix[6]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_23" class="matrix-cell f-left">
                                ${matrix[7]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_24" class="matrix-cell f-left">
                                ${matrix[8]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_25" class="matrix-cell f-left">
                                ${matrix[9]}
                              </div>
                            </div>
                            <div class="col-1"></div>
                          </div>`;
        let bottomRow = `<div class="row row_b col-row row-5">
                            <div class="col-1"></div>
                            <div class="col-2 cell-pad">
                              <div id="col_31" class="matrix-cell f-right">
                                ${matrix[10]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_32" class="matrix-cell">
                                ${matrix[11]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_33" class="matrix-cell f-left">
                                ${matrix[12]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_34" class="matrix-cell f-left">
                                ${matrix[13]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_35" class="matrix-cell f-left">
                                ${matrix[14]}
                              </div>
                            </div>
                            <div class="col-1"></div>
                          </div>`;
        let bottom2Row = `<div class="row col-row row-5">
                            <div class="col-1"></div>
                            <div class="col-2 cell-pad">
                              <div id="col_41" class="matrix-cell f-right">
                                ${matrix[15]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_42" class="matrix-cell">
                                ${matrix[16]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_43" class="matrix-cell f-left">
                                ${matrix[17]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_44" class="matrix-cell f-left">
                                ${matrix[18]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_45" class="matrix-cell f-left">
                                ${matrix[19]}
                              </div>
                            </div>
                            <div class="col-1"></div>
                          </div>`;
        let lastRow = `<div class="row row_b col-row mb-20 row-5">
                            <div class="col-1"></div>
                            <div class="col-2 cell-pad">
                              <div id="col_51" class="matrix-cell f-right">
                                ${matrix[20]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_52" class="matrix-cell">
                                ${matrix[21]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_53" class="matrix-cell f-left">
                                ${matrix[22]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_54" class="matrix-cell f-left">
                                ${matrix[23]}
                              </div>
                            </div>
                            <div class="col-2 cell-pad">
                              <div id="col_55" class="matrix-cell f-left">
                                ${matrix[24]}
                              </div>
                            </div>
                            <div class="col-1"></div>
                          </div>`;
        matrixContent = topRow + middleRow + bottomRow + bottom2Row + lastRow;
      } else {
        matrixContent = `<div style='text-align:center;'><h1>Thanks for playing</h1></div>`;
      }
      return matrixContent;
    },
    getMatrix: function (level) {
      let randomFloat = (min, max) => Math.random() * (max - min) + min;
      let matrixArray = [];
      if (level == 1) {
        for (let i = 0; i < 9; i++) {
          matrixArray.push(randomFloat(0, 0.9).toFixed(1))
        }
      } else if (level == 2) {
        for (let i = 0; i < 16; i++) {
          matrixArray.push(randomFloat(0, 0.9).toFixed(1))
        }
      } else if (level == 3) {
        for (let i = 0; i < 25; i++) {
          matrixArray.push(randomFloat(0, 0.9).toFixed(1))
        }
      }
      return matrixArray;
    }
  },
  beforeCreate: function () {
    $('body').addClass('go_for_morkov');
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('go_for_morkov');
    next();
  },
}